import script from "./PortfolioShareCards.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioShareCards.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioShareCards.vue?vue&type=style&index=0&id=2a04f2a4&scoped=true&lang=css"
import "./PortfolioShareCards.vue?vue&type=style&index=1&id=2a04f2a4&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a04f2a4"]])

export default __exports__